import { EventBus } from './index'

const EVENT_SHOW = 'splash-show'
const EVENT_HIDE = 'splash-hide'

export default {
    EVENT_SHOW,
    EVENT_HIDE,
    show() {
        EventBus.$emit(EVENT_SHOW);
    },
    hide() {
        EventBus.$emit(EVENT_HIDE);
    }
}